export function cloudStorageUrl(path: string) {
  const { storageUrl } = useEnvironment();

  const url = [storageUrl, path].join("/");

  // make sure we don't have double slashes
  return url.replace(/([^:]\/)\/+/g, "$1");
}
